import React from 'react';
import classnames from 'classnames/bind';

import { withSnapPoint } from '@components/snapping-slider';
import { WagtailImageBackground } from '@components/image';
import ShareBar from '@components/share-bar';
import RichText from '@components/rich-text';
import css from './share.module.scss';

const styles = classnames.bind(css);

const ShareSlide = ({
    text = 'The changes we’re making to people’s lives are only possible because of your generosity.',
    backgroundUrl,
    backgroundImage,
    socialLinks,
    slideRef,
}) => {
    return (
        <div ref={slideRef} className={styles('share-slide')}>
            <div className={styles('share-slide__overlay')}>
                <RichText tag="h3" className={styles('share-slide__heading')}>
                    Thank You!
                </RichText>
                <RichText className={styles('share-slide__description')}>{text}</RichText>
                <span className={styles('share-slide__share-text')}>Share this story</span>
                <ShareBar {...socialLinks} className={styles('share-slide__share-bar')} />
                <div className={styles('share-slide__logos')}>
                    <img
                        alt="Upshot logo"
                        className={styles('share-slide__upshot-logo')}
                        src={require('../../images/upshot-logo.svg')}
                    />
                </div>
            </div>
            <WagtailImageBackground
                aria-hidden
                className={styles('share-slide__background')}
                backgroundUrl={backgroundUrl}
                backgroundImage={backgroundImage}
            />
        </div>
    );
};

export default withSnapPoint(ShareSlide);
